export default __webpack_public_path__ + "static/media/inter-v12-latin-regular.817c4274.woff";